var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      _vm._l(_vm.companySettings, function (companySetting) {
        return _c(
          "ul",
          { key: companySetting.to.name, staticClass: "menu-list" },
          [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: companySetting.to,
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(" " + _vm._s(companySetting.label) + " "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }